import Bar from './index.vue'
import Txt003 from './txt003/index.vue'
import Txt004 from './txt004/index.vue'

export const barCodes = {
  'txt001': {
    code: 'Txt001',
    component: Bar
  },
  'txt002': {
    code: 'Txt002',
    component: Bar
  },
  'txt003': {
    code: 'Txt003',
    component: Txt003
  },
  'txt004': {
    code: 'Txt004',
    component: Txt004
  }
}




// WEBPACK FOOTER //
// ./src/public/components/kye-report-form/echarts/bar-x/config.js